// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TGuuMmyurCVVA2 {
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0);
  background-color: var(--dynamic-nav-item-interactable);
  color: var(--dynamic-text);
}
.TGuuMmyurCVVA2:hover {
  background-color: var(--dynamic-nav-item-interactable-hovered);
  color: var(--dynamic-text);
}
.TGuuMmyurCVVA2:active {
  background-color: var(--dynamic-nav-item-interactable-pressed);
  color: var(--dynamic-text);
}
.TGuuMmyurCVVA2.MMCIsBQPYaqGBf {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-highlighted);
  color: var(--dynamic-button-highlighted-text);
}
.TGuuMmyurCVVA2.MMCIsBQPYaqGBf svg circle {
  stroke: var(--dynamic-icon);
}
.TGuuMmyurCVVA2.MMCIsBQPYaqGBf:hover {
  background: var(--dynamic-button-highlighted-hovered);
  color: var(--dynamic-button-highlighted-text);
}
.LwaybRP7q8g03B {
  background-color: var(--ds-background-neutral, #091e420f);
}
html[data-color-mode='dark'] .LwaybRP7q8g03B {
  background-color: var(--ds-background-neutral-subtle-hovered, #a1bdd914);
}
.LwaybRP7q8g03B:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
html[data-color-mode='dark'] .LwaybRP7q8g03B:hover {
  background-color: var(--ds-background-neutral-hovered, #A6C5E229);
}
.LwaybRP7q8g03B:active {
  background: var(--ds-background-neutral-pressed, #091e424f);
}
html[data-color-mode='dark'] .LwaybRP7q8g03B:active {
  background-color: var(--ds-background-neutral-hovered, #A6C5E229);
}
`, ""]);
// Exports
export var joinButton = `TGuuMmyurCVVA2`;
export var highlighted = `MMCIsBQPYaqGBf`;
export var joinButtonHomePage = `LwaybRP7q8g03B`;
export default ___CSS_LOADER_EXPORT___;
